module.exports = __webpack_public_path__ + "static/img/cont45_06.3c04bbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_06.jpg
// module id = EQQQ
// module chunks = 0